import { FormattedMessage } from 'react-intl';

import CheckCircleIcon from '@/assets/icons/check-circle.svg';
import XCircleIcon from '@/assets/icons/x-circle.svg';
import { ChannelIcon } from '@/components/ui/channel-icon';
import { Typography } from '@/components/ui/typography';

import type { OpeningChannelResult } from '../types';

interface ChannelStatusRowProps {
  channel: OpeningChannelResult;
}

export function ChannelStatusRow({ channel }: ChannelStatusRowProps) {
  return (
    <li className="flex items-start justify-between gap-3 px-3">
      <ChannelIcon
        channelSlug={channel.channelSlug}
        variant="large"
        size="xs"
        logoSquareUrl={channel.logoSquareUrl}
        logoRectangleUrl={channel.logoRectangleUrl}
        channelName={channel.channelName}
        displayTitle={channel.displayTitle}
        titleClassName="text-fx-neutral-600 font-normal"
      />

      <div className="flex shrink-0 items-center gap-1">
        {channel.status === 'posted' ? (
          <>
            <img src={CheckCircleIcon} alt="" />
            <Typography variant="small1" className="text-fx-green-800">
              <FormattedMessage
                defaultMessage="Posted"
                description="Status label when a channel posting succeeded"
              />
            </Typography>
          </>
        ) : (
          <>
            <img src={XCircleIcon} alt="" />
            <Typography variant="small1" className="text-fx-rose">
              <FormattedMessage
                defaultMessage="Failed"
                description="Status label when a channel posting failed"
              />
            </Typography>
          </>
        )}
      </div>
    </li>
  );
}
